import React, { Component } from "react";
import Card from "react-md/lib/Cards/Card";
import Avatar from "react-md/lib/Avatars";
import PropTypes from "prop-types";
import { RegistrationShape, LaneShape, isMember, isFlagged } from "../../../utils";

const isLaneAvailable = (lane, selectedUser) => {
  if (lane.status === "open" && selectedUser) {
    if (!lane.isMemberOnly || (lane.isMemberOnly && isMember(selectedUser))) {
      return true;
    }
  }
  return false;
};

class LaneCard extends Component {
  constructor(props) {
    super(props);

    this.handleClick = this.handleClick.bind(this);
  }

  handleClick() {
    const { range, location, lane } = this.props;
    const { selectedUser } = this.props;
    const { onAssignUserToLane, onOpenLaneDetail } = this.props;
    // When assign, staff can assign none-member registration to member lane
    // so only need to check if that lane is open
    if (selectedUser && lane.status === "open") {
      onAssignUserToLane(location, range, lane.number, selectedUser);
    } else {
      onOpenLaneDetail(location, range, lane.number, lane);
    }
  }

  render() {
    const { className, lane, selectedUser } = this.props;

    const colors = {
      open: "white",
      "in-use": "deep-orange",
      overdue: "red",
      "not-available": "grey",
      available: "green",
      reserved: "amber"
    };
    let color = "white";
    let laneStatus = "Open";

    // staff select an user in queue, available lane will turn green
    if (selectedUser && !isFlagged(selectedUser)) {
      if (isLaneAvailable(lane, selectedUser)) {
        color = colors.available;
        laneStatus = "Open";
      } else if (["in-use", "reserved"].indexOf(lane.status) !== -1) {
        color = colors[lane.status.toLowerCase()];
        laneStatus = lane.status;
      } else {
        color = colors["not-available"];
        laneStatus = "Not available";
      }
    } else if (lane.overdue) {
      color = colors.overdue;
      laneStatus = lane.overdueTime;
    } else if (lane.status) {
      color = colors[lane.status.toLowerCase()];
      laneStatus = lane.status;
    }

    return (
      <Card className={`${className} lane-avatar`} onClick={this.handleClick}>
        <div className="lane-avatar--container">
          {lane.label &&
            <h6 className="lane-avatar--label">{lane.label.toUpperCase()}</h6>}
          <Avatar suffix={color}>{lane.number}</Avatar>
          <h6 className="lane-avatar--status">
            {laneStatus.replace("-", " ").toUpperCase()}
          </h6>
        </div>
      </Card>
    );
  }
}

LaneCard.propTypes = {
  range: PropTypes.string.isRequired,
  location: PropTypes.string.isRequired,
  lane: LaneShape.isRequired,
  selectedUser: RegistrationShape,
  onAssignUserToLane: PropTypes.func.isRequired,
  onOpenLaneDetail: PropTypes.func.isRequired,
  className: PropTypes.string.isRequired
};

LaneCard.defaultProps = {
  selectedUser: null
};

export default LaneCard;



// WEBPACK FOOTER //
// ./src/staff/components/Range/LaneCard/LaneCard.jsx